var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2.15765C1 0.984699 1.91033 0 3.07402 0H13.1096C14.2733 0 15.1836 0.984707 15.1836 2.15765V19.1345C15.1836 19.2842 15.1003 19.4214 14.9676 19.4905C14.8348 19.5596 14.6746 19.5492 14.552 19.4633L8.0918 14.9412L1.63162 19.4633C1.509 19.5492 1.3488 19.5596 1.21604 19.4905C1.08328 19.4214 1 19.2842 1 19.1345V2.15765ZM3.07402 0.802845C2.39019 0.802845 1.80284 1.39073 1.80284 2.15765V18.3635L7.8616 14.1224C7.99981 14.0256 8.18378 14.0256 8.322 14.1224L14.3807 18.3635V2.15765C14.3807 1.39072 13.7934 0.802845 13.1096 0.802845H3.07402Z",
    fill: "#3D3D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.c2a7178b5470bb88e718771f1cd59d32.svg";
export { ForwardRef as ReactComponent };